export class Domicilio {
	authId: number;
	domicilio: string;
	entreCalles: string;
	localidad: string;
	codigoPostal: number;
	telLaboral: string;
	informacionAdicional: string;
}
